import { render, staticRenderFns } from "./c_merchantName.vue?vue&type=template&id=3ac1d968&scoped=true"
import script from "./c_merchantName.vue?vue&type=script&lang=js"
export * from "./c_merchantName.vue?vue&type=script&lang=js"
import style0 from "./c_merchantName.vue?vue&type=style&index=0&id=3ac1d968&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac1d968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac1d968')) {
      api.createRecord('3ac1d968', component.options)
    } else {
      api.reload('3ac1d968', component.options)
    }
    module.hot.accept("./c_merchantName.vue?vue&type=template&id=3ac1d968&scoped=true", function () {
      api.rerender('3ac1d968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_merchantName.vue"
export default component.exports